export default [
  //简易项目列表页面
  {
    path: "/:lang/SimpleProject/List/Index",
    name: "SimpleProjectIndex",
    alias: [
      "/:lang/SimpleProject/List/Index",
      "/:lang/SimpleProject/List/Index",
      "/:lang/SimpleProject/List/Index",
      "/:lang/SimpleProject/List/Index",
      "/:lang/SimpleProject/List/Index",
    ],
    meta: {
      title: "项目列表",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/SimpleProject/List/Index.vue"),
  },
  // 简易项目详情
  {
    path: "/:lang/SimpleProject/Detail/Index",
    name: "SimpleProjectDetail",
    alias: [
      "/:lang/SimpleProject/Detail/Index",
      "/:lang/SimpleProject/Detail/Index",
      "/:lang/SimpleProject/Detail/Index",
      "/:lang/SimpleProject/Detail/Index",
      "/:lang/SimpleProject/Detail/Index",
    ],
    meta: {
      title: "项目详情",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/SimpleProject/Detail/Index.vue"),
  },
];
